/**
 * The HTTP status behind an API failure, whatever layer threw it: an axios
 * error carries it on `response.status`, an RTK Query `FetchBaseQueryError` on
 * `status` — where it can also be a string tag (`FETCH_ERROR`, `PARSING_ERROR`)
 * rather than a status, hence the number check on both.
 */
export function getApiErrorStatus(error: unknown): number | undefined {
  if (typeof error !== 'object' || error === null) return undefined;

  const { response, status } = error as {
    response?: { status?: unknown };
    status?: unknown;
  };

  if (typeof response?.status === 'number') return response.status;

  return typeof status === 'number' ? status : undefined;
}
